export default __webpack_public_path__ + "static/media/009-sausage.f42c8846.svg";